module.exports = __webpack_public_path__ + "static/media/green-check-contact.e61a3ad3.svg";